/**
 * Get the index of the first visible slide (if there is 2 slides hidden before the current slide, then this value will be 2)
 * If it's not a loop, the first visible slide will depend on the current slide real index
 */
export const getFirstVisibleSlideIndex = ({ loop, currentSlideIndex }) => {
	return loop ? 2 /*(items.length - visible - 1)*/ : currentSlideIndex;
};
